export function AssetListSkeleton() {
  return (
    <div className="flex flex-col w-full gap-3">
      <div className="flex flex-row w-full flex-1">
        <div className="pb-0.5 h-16 flex-grow rounded-t-2xl skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="pb-0.5 h-16 flex-grow skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="pb-0.5 h-16 flex-grow skeleton" />
      </div>
      <div className="flex flex-row w-full flex-1">
        <div className="pb-0.5 h-16 flex-grow rounded-b-2xl skeleton" />
      </div>
    </div>
  );
}
